import { createSlice } from '@reduxjs/toolkit';
const formSlice = createSlice({
  name: 'form',
  initialState: {
    submitForm: false,
    formData: null,
    raccolta: [],
    certificazioni: [],
    moddiapplicazione: [],
    siccurezza: [],
    tipodicontenitore: [],
    prodotto: [],
    varientaDelluva: [],
    varientaVigneto: []
  },
  reducers: {
    triggerFormSubmit: (state) => {
      state.submitForm = true;
    },
    resetFormSubmit: (state) => {
      state.submitForm = false;
    },
    storeFormData: (state, action) => {
      state.formData = action.payload;
    },
    resetFormData: (state) => {
      state.formData = null;
    },
    setRaccolta: (state, action) => {
      state.raccolta = action.payload;
    },
    setCertificazioni: (state, action) => {
      state.certificazioni = action.payload;
    },
    setModdiapplicazione: (state, action) => {
      state.moddiapplicazione = action.payload;
    },
    setSiccurezza: (state, action) => {
      state.siccurezza = action.payload;
    },
    setTipodicontenitore: (state, action) => {
      state.tipodicontenitore = action.payload;
    },
    setProdotto: (state, action) => {
      state.prodotto = action.payload;
    },
    setVarientaDelluva: (state, action) => {
      state.varientaDelluva = action.payload;
    },
    setVarientaVigneto: (state, action) => {
      state.varientaVigneto = action.payload;
    },
    enumRequestStart: (state, action) => {
      state.enumsLoading[action.payload] = true;
      state.enumsError[action.payload] = null;
    },
    enumRequestSuccess: (state, action) => {
      state.enumsLoading[action.payload] = false;
    },
    enumRequestFailure: (state, action) => {
      const { enumType, error } = action.payload;
      state.enumsLoading[enumType] = false;
      state.enumsError[enumType] = error;
    }
  },
});
export const {
  enumRequestStart,
  enumRequestSuccess,
  enumRequestFailure,
  triggerFormSubmit,
  resetFormSubmit,
  storeFormData,
  resetFormData,
  setProdotto,
  setVarientaDelluva,
  setVarientaVigneto,
  setTipodicontenitore,
  setSiccurezza,
  setModdiapplicazione,
  setCertificazioni,
  setRaccolta,
} = formSlice.actions;
export const selectRaccolta = (state) => state.produzioniForm?.raccolta;
export const selectCertificazioni = (state) => state.produzioniForm?.certificazioni;
export const selectModdiapplicazione = (state) => state.produzioniForm?.moddiapplicazione;
export const selectSiccurezza = (state) => state.produzioniForm?.siccurezza;
export const selectTipodicontenitore = (state) => state.produzioniForm?.tipodicontenitore;
export const selectProdotto = (state) => state.produzioniForm?.prodotto;
export const selectVarientaDelluva = (state) => state.produzioniForm?.varientaDelluva;
export const selectVarientaVigneto = (state) => state.produzioniForm?.varientaVigneto;
export default formSlice.reducer;